export default __webpack_public_path__ + "3ef25a629d1df9a2d9f20f1aa126b181.svg";